import React from "react";
import { Line } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import { Chart } from "chart.js";
import zoomPlugin from "chartjs-plugin-zoom";
import { useEffect, useState, useRef } from "react";

function SimulationChart(props) {
  Chart.register(zoomPlugin);

  const [chartSize, setChartSize] = useState({
    height: 0,
    width: 0,
  });

  // count chart size
  useEffect(() => {
    setChartSize({
      ...chartSize,
      height: document.documentElement.clientHeight - 216,
      width:
        props.viewMode === "main-page-fullView"
          ? document.documentElement.clientWidth - 640
          : props.viewMode === "main-page-onlyGraph"
          ? document.documentElement.clientWidth
          : document.documentElement.clientWidth - 320,
    });
  }, [props.viewMode]);

  const options = {
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: false,
        suggestedMin: 0,
        suggestedMax: props.maxChartValue,
      },
    },
    plugins: {
      zoom: {
        pan: {
          enabled: true,
          mode: "x",
          threshold: 2,
        },
        zoom: {
          wheel: {
            enabled: true,
          },
          mode: "x",
        },
      },
      tooltip: {
        padding: 10,
        filter: (label) => {
          return (
            label.dataset.label !== "SUBTRACTION_YELLOW_ZONE" &&
            label.dataset.label !== "SUBTRACTION_RED_BASE_ZONE"
          );
        },
      },
      legend: {
        display: true,
        position: "bottom",
        labels: {
          filter: (legendItem) => {
            return (
              legendItem.text !== "SUBTRACTION_YELLOW_ZONE" &&
              legendItem.text !== "SUBTRACTION_RED_BASE_ZONE"
            );
          },
        },
      },
    },
    interaction: {
      mode: "index",
    },
  };
  return (
    <div style={{ width: chartSize.width, height: chartSize.height }}>
      <Line data={props.chartData} options={options} />
    </div>
  );
}

export default SimulationChart;
